import { ResolveFn, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { HxRecipeService, RecipeModel, WorkflowModel, WorkflowStepModel } from 'hx-services';
import { WorkflowListComponent } from '@adm-web-app/modules/workflows/list/workflow-list.component';
import { WorkflowStepListComponent } from '@adm-web-app/modules/workflows/steps/list/workflow-step-list.component';
import { WorkflowRecipeListComponent } from '@adm-web-app/modules/workflows/recipes/list/workflow-recipe-list.component';
import { WorkflowEditComponent } from '@adm-web-app/modules/workflows/edit/workflow-edit.component';
import { WorkflowStepEditComponent } from '@adm-web-app/modules/workflows/steps/edit/workflow-step-edit.component';
import { WorkflowRecipeEditComponent } from '@adm-web-app/modules/workflows/recipes/edit/workflow-recipe-edit.component';

const workflowResolveFn: ResolveFn<WorkflowModel> = route => inject(HxRecipeService)
  .getWorkflowById(Number(route.paramMap.get('workflowId')));
const workflowStepResolveFn: ResolveFn<WorkflowStepModel> = route => inject(HxRecipeService)
  .getWorkflowStepById(Number(route.paramMap.get('workflowId')), Number(route.paramMap.get('workflowStepId')));
const workflowRecipeResolveFn: ResolveFn<RecipeModel> = route => inject(HxRecipeService)
  .getRecipeById(Number(route.paramMap.get('recipeId')));

export const workflowsRoutes: Routes = [
  {
    path: '', component: WorkflowListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: WorkflowEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':workflowId/edit', component: WorkflowEditComponent,
    resolve: {
      model: workflowResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
  {
    path: ':workflowId/steps', component: WorkflowStepListComponent,
    resolve: {
      model: workflowResolveFn,
    },
    data: {
      breadcrumb: 'StepList'
    }
  },
  {
    path: ':workflowId/steps/new', component: WorkflowStepEditComponent,
    resolve: {
      workflow: workflowResolveFn,
    },
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':workflowId/steps/:workflowStepId/edit', component: WorkflowStepEditComponent,
    resolve: {
      workflow: workflowResolveFn,
      model: workflowStepResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
  {
    path: ':workflowId/steps/:workflowStepId/recipes', component: WorkflowRecipeListComponent,
    resolve: {
      workflow: workflowResolveFn,
      step: workflowStepResolveFn,
    },
    data: {
      breadcrumb: 'RecipeList'
    }
  },
  {
    path: ':workflowId/steps/:workflowStepId/recipes/new', component: WorkflowRecipeEditComponent,
    resolve: {
      workflow: workflowResolveFn,
      step: workflowStepResolveFn,
    },
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':workflowId/steps/:workflowStepId/recipes/:recipeId/edit', component: WorkflowRecipeEditComponent,
    resolve: {
      workflow: workflowResolveFn,
      step: workflowStepResolveFn,
      model: workflowRecipeResolveFn,
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
